export const adminAccounts = {
  "admin.accounts.pageTitle": "Gestione Account",
  "admin.accounts.pageDescription": "Gestisci e visualizza tutti gli account utente nel sistema",
  "admin.accounts.title": "Gestione Account", 
  "admin.accounts.subtitle": "Visualizza e gestisci tutti gli account utente con opzioni complete di filtro e ordinamento",
  "admin.accounts.errorTitle": "Errore nel Caricamento Account",
  "admin.accounts.errorMessage": "Errore nel caricamento dei dati degli account. Riprova.",
  "admin.accounts.retryButton": "Riprova",

  // Filters section
  "admin.accounts.filters.title": "Filtri Account",
  "admin.accounts.filters.accountInformationTitle": "Informazioni Account",
  "admin.accounts.filters.dateRangeTitle": "Intervallo Date",
  "admin.accounts.filters.balanceRangeTitle": "Intervallo Saldi",
  "admin.accounts.filters.accountNumber": "Numero Account",
  "admin.accounts.filters.accountNumberPlaceholder": "Inserisci numero esatto account",
  "admin.accounts.filters.username": "Nome Utente", 
  "admin.accounts.filters.usernamePlaceholder": "Inserisci nome utente esatto",
  "admin.accounts.filters.accountStatus": "Stato Account",
  "admin.accounts.filters.accountStatusPlaceholder": "Seleziona stato account",
  "admin.accounts.filters.allStatuses": "Tutti gli Stati",
  "admin.accounts.filters.dateFrom": "Account Aperto Dal (yyyy-mm-dd)",
  "admin.accounts.filters.dateTo": "Account Aperto Al (yyyy-mm-dd)",
  "admin.accounts.filters.accountShareType": "Tipo Quota Account",
  "admin.accounts.filters.accountShareTypePlaceholder": "Seleziona tipo quota",
  "admin.accounts.filters.allShareTypes": "Tutti i Tipi Quota",
  "admin.accounts.filters.programPercent": "Percentuale Programma",
  "admin.accounts.filters.programPercentPlaceholder": "Seleziona percentuale programma",
  "admin.accounts.filters.allProgramPercents": "Tutte le Percentuali Programma",
  "admin.accounts.filters.balanceMin": "Saldo Minimo",
  "admin.accounts.filters.balanceMinPlaceholder": "Inserisci saldo minimo",
  "admin.accounts.filters.balanceMax": "Saldo Massimo", 
  "admin.accounts.filters.balanceMaxPlaceholder": "Inserisci saldo massimo",
  "admin.accounts.filters.applyFilters": "Applica Filtri",
  "admin.accounts.filters.clearFilters": "Cancella Filtri",

  // Table section
  "admin.accounts.table.title": "Account Utente",
  "admin.accounts.table.showing": "Mostrando",
  "admin.accounts.table.of": "di",
  "admin.accounts.table.accounts": "account",
  "admin.accounts.table.accountNumber": "Numero Account",
  "admin.accounts.table.username": "Nome Utente",
  "admin.accounts.table.name": "Nome",
  "admin.accounts.table.status": "Stato",
  "admin.accounts.table.shareType": "Tipo Quota",
  "admin.accounts.table.programPercent": "Programma %",
  "admin.accounts.table.balance": "Saldo", 
  "admin.accounts.table.creationDate": "Data Creazione",
  "admin.accounts.table.lastUpdate": "Ultimo Aggiornamento",
  "admin.accounts.table.errorMessage": "Errore nel caricamento dati account",
  "admin.accounts.table.noDataMessage": "Nessun account trovato che corrisponda ai filtri attuali",

  // Status translations
  "admin.accounts.table.status.active": "Attivo",
  "admin.accounts.table.status.inactive": "Inattivo",

  // Profits page translations
  "admin.accounts.profits.pageTitle": "Gestione Profitti Account",
  "admin.accounts.profits.pageDescription": "Visualizza e analizza la cronologia dei profitti degli account con opzioni di filtro complete",
  "admin.accounts.profits.title": "Gestione Profitti Account",
  "admin.accounts.profits.subtitle": "Vista completa della cronologia dei profitti degli account con filtri e analisi avanzate",
  "admin.accounts.profits.errorTitle": "Errore nel Caricamento Dati Profitti",
  "admin.accounts.profits.errorMessage": "Errore nel caricamento dei dati profitti degli account. Riprova.",
  "admin.accounts.profits.retryButton": "Riprova",

  // Profits filters section
  "admin.accounts.profits.filters.title": "Filtri Profitti",
  "admin.accounts.profits.filters.accountInformationTitle": "Informazioni Account",
  "admin.accounts.profits.filters.periodTitle": "Periodo",
  "admin.accounts.profits.filters.profitsTitle": "Profitti",
  "admin.accounts.profits.filters.accountNumber": "Numero Account",
  "admin.accounts.profits.filters.accountNumberPlaceholder": "Inserisci numero esatto account",
  "admin.accounts.profits.filters.username": "Nome Utente",
  "admin.accounts.profits.filters.usernamePlaceholder": "Inserisci nome utente esatto",
  "admin.accounts.profits.filters.accountShare": "Quota Account",
  "admin.accounts.profits.filters.accountSharePlaceholder": "Seleziona tipo quota account",
  "admin.accounts.profits.filters.allAccountShares": "Tutti i Tipi Quota",
  "admin.accounts.profits.filters.dateFrom": "Periodo Dal (yyyy-mm-dd)",
  "admin.accounts.profits.filters.dateTo": "Periodo Al (yyyy-mm-dd)",
  "admin.accounts.profits.filters.userProfitRange": "Intervallo Profitto Utente",
  "admin.accounts.profits.filters.userProfitMin": "Profitto Utente Minimo",
  "admin.accounts.profits.filters.userProfitMinPlaceholder": "Inserisci profitto utente minimo",
  "admin.accounts.profits.filters.userProfitMax": "Profitto Utente Massimo",
  "admin.accounts.profits.filters.userProfitMaxPlaceholder": "Inserisci profitto utente massimo",
  "admin.accounts.profits.filters.tradingProfitRange": "Intervallo Profitto Trading",
  "admin.accounts.profits.filters.tradingProfitMin": "Profitto Trading Minimo",
  "admin.accounts.profits.filters.tradingProfitMinPlaceholder": "Inserisci profitto trading minimo",
  "admin.accounts.profits.filters.tradingProfitMax": "Profitto Trading Massimo",
  "admin.accounts.profits.filters.tradingProfitMaxPlaceholder": "Inserisci profitto trading massimo",
  "admin.accounts.profits.filters.programProfitRange": "Intervallo Profitto Programma",
  "admin.accounts.profits.filters.programProfitMin": "Profitto Programma Minimo",
  "admin.accounts.profits.filters.programProfitMinPlaceholder": "Inserisci profitto programma minimo",
  "admin.accounts.profits.filters.programProfitMax": "Profitto Programma Massimo",
  "admin.accounts.profits.filters.programProfitMaxPlaceholder": "Inserisci profitto programma massimo",
  "admin.accounts.profits.filters.applyFilters": "Applica Filtri",
  "admin.accounts.profits.filters.clearFilters": "Cancella Filtri",

  // Profits table section
  "admin.accounts.profits.table.title": "Dati Profitti Account",
  "admin.accounts.profits.table.showing": "Mostrando",
  "admin.accounts.profits.table.of": "di",
  "admin.accounts.profits.table.records": "record",
  "admin.accounts.profits.table.accountNumber": "Numero Account",
  "admin.accounts.profits.table.username": "Nome Utente",
  "admin.accounts.profits.table.name": "Nome",
  "admin.accounts.profits.table.shareType": "Tipo Quota",
  "admin.accounts.profits.table.period": "Periodo",
  "admin.accounts.profits.table.userProfit": "Profitto Utente",
  "admin.accounts.profits.table.tradingProfit": "Profitto Trading",
  "admin.accounts.profits.table.programProfit": "Profitto Programma",
  "admin.accounts.profits.table.errorMessage": "Errore nel caricamento dati profitti",
  "admin.accounts.profits.table.noDataMessage": "Nessun record di profitto trovato che corrisponda ai filtri attuali",

  // Profits Totals page translations
  "admin.accounts.profitsTotals.title": "Gestione Totali Profitti Conti",
  "admin.accounts.profitsTotals.subtitle": "Visualizza e analizza i profitti totali dei conti con opzioni di filtro complete",
  "admin.accounts.profitsTotals.errorTitle": "Errore nel Caricamento dei Totali Profitti",
  "admin.accounts.profitsTotals.errorMessage": "Errore nel caricamento dei dati dei totali profitti dei conti. Si prega di riprovare.",
  "admin.accounts.profitsTotals.retryButton": "Riprova",

  // Profits Totals filters section
  "admin.accounts.profitsTotals.filters.title": "Filtri Totali Profitti",
  "admin.accounts.profitsTotals.filters.accountInformationTitle": "Informazioni Conto",
  "admin.accounts.profitsTotals.filters.profitsTitle": "Profitti",
  "admin.accounts.profitsTotals.filters.accountNumber": "Numero Conto",
  "admin.accounts.profitsTotals.filters.accountNumberPlaceholder": "Inserisci il numero di conto esatto",
  "admin.accounts.profitsTotals.filters.username": "Nome Utente",
  "admin.accounts.profitsTotals.filters.usernamePlaceholder": "Inserisci il nome utente esatto",
  "admin.accounts.profitsTotals.filters.accountShare": "Quota Conto",
  "admin.accounts.profitsTotals.filters.accountSharePlaceholder": "Seleziona il tipo di quota conto",
  "admin.accounts.profitsTotals.filters.allAccountShares": "Tutti i Tipi di Quota",
  "admin.accounts.profitsTotals.filters.userProfitRange": "Intervallo Profitto Utente",
  "admin.accounts.profitsTotals.filters.userProfitMin": "Profitto Minimo Utente",
  "admin.accounts.profitsTotals.filters.userProfitMinPlaceholder": "Inserisci il profitto minimo dell'utente",
  "admin.accounts.profitsTotals.filters.userProfitMax": "Profitto Massimo Utente",
  "admin.accounts.profitsTotals.filters.userProfitMaxPlaceholder": "Inserisci il profitto massimo dell'utente",
  "admin.accounts.profitsTotals.filters.tradingProfitRange": "Intervallo Profitto Trading",
  "admin.accounts.profitsTotals.filters.tradingProfitMin": "Profitto Minimo Trading",
  "admin.accounts.profitsTotals.filters.tradingProfitMinPlaceholder": "Inserisci il profitto minimo di trading",
  "admin.accounts.profitsTotals.filters.tradingProfitMax": "Profitto Massimo Trading",
  "admin.accounts.profitsTotals.filters.tradingProfitMaxPlaceholder": "Inserisci il profitto massimo di trading",
  "admin.accounts.profitsTotals.filters.programProfitRange": "Intervallo Profitto Programma",
  "admin.accounts.profitsTotals.filters.programProfitMin": "Profitto Minimo Programma",
  "admin.accounts.profitsTotals.filters.programProfitMinPlaceholder": "Inserisci il profitto minimo del programma",
  "admin.accounts.profitsTotals.filters.programProfitMax": "Profitto Massimo Programma",
  "admin.accounts.profitsTotals.filters.programProfitMaxPlaceholder": "Inserisci il profitto massimo del programma",
  "admin.accounts.profitsTotals.filters.applyFilters": "Applica Filtri",
  "admin.accounts.profitsTotals.filters.clearFilters": "Cancella Filtri",

  // Profits Totals table section
  "admin.accounts.profitsTotals.table.title": "Dati Totali Profitti Conti",
  "admin.accounts.profitsTotals.table.showing": "Mostrando",
  "admin.accounts.profitsTotals.table.of": "di",
  "admin.accounts.profitsTotals.table.records": "record",
  "admin.accounts.profitsTotals.table.accountNumber": "Numero Conto",
  "admin.accounts.profitsTotals.table.username": "Nome Utente",
  "admin.accounts.profitsTotals.table.name": "Nome",
  "admin.accounts.profitsTotals.table.shareType": "Tipo Quota",
  "admin.accounts.profitsTotals.table.userProfit": "Profitto Utente",
  "admin.accounts.profitsTotals.table.tradingProfit": "Profitto Trading",
  "admin.accounts.profitsTotals.table.programProfit": "Profitto Programma",
  "admin.accounts.profitsTotals.table.errorMessage": "Errore nel caricamento dei dati dei totali profitti",
  "admin.accounts.profitsTotals.table.noDataMessage": "Nessun totale profitto trovato corrispondente ai filtri attuali",

  // Profits Registration page translations
  "admin.accounts.profitsRegistration.title": "Registra Profitti Trading",
  "admin.accounts.profitsRegistration.subtitle": "Registra i profitti mensili di trading per tutti i conti broker nel sistema",
  "admin.accounts.profitsRegistration.registerSection.title": "Registra Profitti Trading",
  "admin.accounts.profitsRegistration.registerSection.monthLabel": "Mese",
  "admin.accounts.profitsRegistration.registerSection.monthDescription": "Il formato del mese è \"yyyy-mm-01\", i profitti del mese precedente vengono registrati il primo giorno del mese corrente.",
  "admin.accounts.profitsRegistration.registerSection.monthPlaceholder": "yyyy-mm-01",
  "admin.accounts.profitsRegistration.registerSection.registerButton": "Registra Profitti Trading",
  "admin.accounts.profitsRegistration.resultSection.title": "Risultato",
  "admin.accounts.profitsRegistration.resultSection.operationResult": "Risultato Operazione",
  "admin.accounts.profitsRegistration.resultSection.success": "Successo",
  "admin.accounts.profitsRegistration.resultSection.fail": "Fallito",
  "admin.accounts.profitsRegistration.resultSection.numBrokerAccounts": "Num conti broker",
  "admin.accounts.profitsRegistration.resultSection.numRegisteredAccounts": "Num conti registrati",
  "admin.accounts.profitsRegistration.resultSection.accountsNotRegistered": "Conti non registrati",
  "admin.accounts.profitsRegistration.resultSection.accountsAlreadyRegistered": "Profitti di conti già registrati",
  "admin.accounts.profitsRegistration.resultSection.totalProfit": "Profitto Totale",
  
  // Validation messages
  "admin.accounts.profitsRegistration.validation.invalidFormat": "Il mese deve essere nel formato yyyy-mm-01",
  "admin.accounts.profitsRegistration.validation.invalidDate": "Data non valida",
  "admin.accounts.profitsRegistration.validation.invalidMonth": "Il mese deve essere compreso tra 01 e 12",
  "admin.accounts.profitsRegistration.validation.futureMonth": "Impossibile registrare profitti per mesi futuri",

  // Toast messages
  "admin.accounts.profitsRegistration.messages.success": "Profitti Registrati con Successo",
  "admin.accounts.profitsRegistration.messages.successDescription": "Profitti del conto registrati con successo",
  "admin.accounts.profitsRegistration.messages.error": "Errore di Registrazione",
  "admin.accounts.profitsRegistration.messages.csrfError": "Impossibile generare il token di sicurezza",
  "admin.accounts.profitsRegistration.messages.authError": "Autenticazione richiesta",
  "admin.accounts.profitsRegistration.messages.serverError": "Si è verificato un errore del server",
  "admin.accounts.profitsRegistration.messages.operationFailed": "Registrazione profitti fallita",
  "admin.accounts.profitsRegistration.messages.unexpectedError": "Si è verificato un errore imprevisto",

  // Balance Update page translations
  "admin.accounts.balanceUpdate.title": "Aggiorna Saldi Conti",
  "admin.accounts.balanceUpdate.subtitle": "Aggiorna il saldo corrente per tutti i conti di trading dal sistema broker",
  "admin.accounts.balanceUpdate.updateSection.title": "Aggiorna Saldi Conti",
  "admin.accounts.balanceUpdate.updateSection.updateButton": "Aggiorna Saldi Conti",
  "admin.accounts.balanceUpdate.resultSection.title": "Risultato",
  "admin.accounts.balanceUpdate.resultSection.operationResult": "Risultato Operazione",
  "admin.accounts.balanceUpdate.resultSection.success": "Successo",
  "admin.accounts.balanceUpdate.resultSection.fail": "Fallito",
  "admin.accounts.balanceUpdate.resultSection.numBrokerAccounts": "Num conti broker",
  "admin.accounts.balanceUpdate.resultSection.numUpdatedAccounts": "Num conti aggiornati",
  "admin.accounts.balanceUpdate.resultSection.accountsNotRegistered": "Conti non registrati",
  "admin.accounts.balanceUpdate.resultSection.totalFunds": "Fondi Totali",

  // Balance Update toast messages
  "admin.accounts.balanceUpdate.messages.success": "Saldi Aggiornati con Successo",
  "admin.accounts.balanceUpdate.messages.successDescription": "Saldi del conto aggiornati con successo",
  "admin.accounts.balanceUpdate.messages.error": "Errore di Aggiornamento",
  "admin.accounts.balanceUpdate.messages.csrfError": "Impossibile generare il token di sicurezza",
  "admin.accounts.balanceUpdate.messages.authError": "Autenticazione richiesta",
  "admin.accounts.balanceUpdate.messages.serverError": "Si è verificato un errore del server",
  "admin.accounts.balanceUpdate.messages.operationFailed": "Aggiornamento saldi fallito",
  "admin.accounts.balanceUpdate.messages.unexpectedError": "Si è verificato un errore imprevisto",

  // Auto Account Registration page translations
  "admin.accounts.autoRegister.title": "Registrazione Automatica Conti",
  "admin.accounts.autoRegister.subtitle": "Registra automaticamente i conti di trading degli utenti dal sistema broker",
  "admin.accounts.autoRegister.registerSection.title": "Registra Conti Automaticamente",
  "admin.accounts.autoRegister.registerSection.registerButton": "Registra Conti Automaticamente",
  "admin.accounts.autoRegister.resultSection.title": "Risultato",
  "admin.accounts.autoRegister.resultSection.operationResult": "Risultato Operazione",
  "admin.accounts.autoRegister.resultSection.success": "Successo",
  "admin.accounts.autoRegister.resultSection.fail": "Fallito",
  "admin.accounts.autoRegister.resultSection.matchedUsers": "Conti Corrispondenti",
  "admin.accounts.autoRegister.resultSection.unmatchedUsers": "Conti Non Corrispondenti",
  "admin.accounts.autoRegister.resultSection.usersWithoutAccounts": "Utenti Senza Conti",
  "admin.accounts.autoRegister.resultSection.ignoredOfferName": "Nome Offerta Ignorato",
  "admin.accounts.autoRegister.resultSection.ignoredIds": "ID Ignorati",
  "admin.accounts.autoRegister.messages.success": "Registrazione Automatica Completata con Successo",
  "admin.accounts.autoRegister.messages.successDescription": "Conti registrati con successo",
  "admin.accounts.autoRegister.messages.error": "Errore di Registrazione Automatica",
  "admin.accounts.autoRegister.messages.csrfError": "Impossibile generare il token di sicurezza",
  "admin.accounts.autoRegister.messages.authError": "Autenticazione richiesta",
  "admin.accounts.autoRegister.messages.serverError": "Si è verificato un errore del server",
  "admin.accounts.autoRegister.messages.operationFailed": "Registrazione automatica fallita",
  "admin.accounts.autoRegister.messages.unexpectedError": "Si è verificato un errore imprevisto",
};